import PropTypes from 'prop-types';

/**
 * PageContainer Component
 *
 * Wrapper component that provides consistent page layout structure across the application.
 * Includes max-width, padding, and vertical spacing.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display within the container
 * @param {string} [props.className] - Additional CSS classes to apply
 * @param {Object} [props.dragHandlers] - Optional drag and drop handlers
 * @param {boolean} [props.isDragging] - Optional dragging state (not used for visual feedback)
 *
 * @example
 * <PageContainer>
 *   <Breadcrumb items={breadcrumbItems} />
 *   <Title level={1}>Page Title</Title>
 *   ...
 * </PageContainer>
 */
export function PageContainer({ children, className = '', dragHandlers, isDragging }) {
  return (
    <div
      className={`max-w-7xl mx-auto p-4 sm:px-18 sm:py-20 space-y-4 sm:space-y-6 ${className}`}
      {...(dragHandlers || {})}
    >
      {children}
    </div>
  );
}

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dragHandlers: PropTypes.object,
  isDragging: PropTypes.bool,
};
